export * from "./Card.settings";
